import React from "react";
import styled from "@emotion/styled";

import { Color } from "../../utils/color";

export const MailInput = () => {
  return (
    <SInput>
      <label>
        *メールアドレス
        <input type="mail" placeholder="sample@xxxx.com" />
      </label>
      <label>
        *メールアドレス（確認）
        <input type="mail" placeholder="sample@xxxx.com" />
      </label>
    </SInput>
  );
};

const SInput = styled.div`
  margin-top: 3rem;
  label {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    font-weight: 500;
    color: ${Color.dark};
    line-height: 1;
    &:nth-of-type(2) {
      margin-top: 2.5rem;
    }
    input {
      border: none;
      width: 100%;
      border: 1px solid ${Color.light};
      background-color: ${Color.light};
      border-radius: 8px;
      padding: 1rem 1.5rem;
      font-size: 0.9rem;
      line-height: 1;
      transition: border 0.2s;
      margin-top: 1.5rem;
      &:focus {
        outline: none;
        border: 1px solid ${Color.primary};
      }
    }
  }
`;
